import React from 'react';
import styled from 'styled-components';
import ArrowIcon from '@catalogo/theme-svg/arrow.svg';
import { ITitleComponentProps } from '../types';

const TitleContainer = styled.div<{ $isVisible: boolean; $paddingTitleAxisX?: number }>`
  padding: 16px 8px;
  margin: 0px 8px;
  display: flex;
  place-content: space-between;
  cursor: pointer;
  text-transform: ${({ theme }) => theme.titleTransform};
  ${({ $isVisible }) => $isVisible && 'border-bottom: 1px solid #e8e8e8;'}

  @media screen and (min-width: 1024px) {
    padding: ${({ $paddingTitleAxisX }) => `${$paddingTitleAxisX}px 0px`};
    margin: 0 16px;
  }
`;

const TitleUI = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.titleColor};

  @media screen and (min-width: 1024px) {
    font-size: 21px;
  }
`;

const ArrowIconUI = styled(ArrowIcon)<{ $isVisible: boolean }>`
  fill: ${({ theme }) => theme.titleColor};
  width: 12px;
  height: 12px;
  display: flex;
  flex-direction: column;
  align-self: center;
  ${({ $isVisible }) => $isVisible && `transform: rotate(180deg);`}
  transition: transform 500ms;
`;

export const Title: React.FC<ITitleComponentProps> = ({
  toggleVisible,
  title,
  isVisible,
  htmlEl,
  paddingTitleAxisX,
}) => (
  <TitleContainer $isVisible={isVisible} onClick={toggleVisible} $paddingTitleAxisX={paddingTitleAxisX}>
    <TitleUI as={htmlEl as never}>{title}</TitleUI>
    <ArrowIconUI $isVisible={isVisible} />
  </TitleContainer>
);

export default Title;
